import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import appUserService from '../../services/appUserService'
import userProductService from '../../services/userProductService'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import BenefitRow from './components/BenefitRow'
import BaseTitle from '../../components/BasicComponent/BaseTitle'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BasePopup from '../../components/BasicComponent/BasePopup'
import NotifyPackageBanner from './components/NotifyPackageBanner'
import benifit1 from '../../assets/images/benifit_1.png'
import benifit2 from '../../assets/images/benifit_2.png'
import benifit3 from '../../assets/images/benifit_3.png'
import benifit4 from '../../assets/images/benifit_4.png'
import benifit5 from '../../assets/images/benifit_5.png'
import benifit6 from '../../assets/images/benifit_6.png'
import benifit7 from '../../assets/images/benifit_7.png'
import benifit8 from '../../assets/images/benifit_8.png'
import benifit9 from '../../assets/images/benifit_9.png'
import benifit10 from '../../assets/images/benifit_10.png'
import benifit11 from '../../assets/images/benifit_11.png'
import trafficFineAutoRenew from '../../assets/images/traffic_fine_auto_renew.png'
import './index.scss'

const BENEFITS = {
  1: 'Thông báo khi có vi phạm',
  2: 'Thông báo khi có vi phạm mới',
  3: 'Thông báo phạt nguội',
  4: 'Thông báo hạn đăng kiểm',
  5: 'Ưu đãi 30% khi mua BH TNDS',
  6: 'Trợ lý tư vấn bảo hiểm',
  7: 'Trợ lý hỗ trợ thủ tục bảo hiểm',
  8: 'Hỗ trợ gói tín dụng chi phí giao thông',
  9: 'Hỗ trợ tặng thẻ tín dụng ưu đãi',
  10: 'Hỗ trợ ưu đãi khi mua gói cứu hộ xe máy',
  11: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô',
  12: 'SMS nhận thông báo tự động hằng tuần',
  13: 'Lịch sử vi phạm và trạng thái xử lý từ Cục Cảnh Sát Giao Thông',
  14: 'Tự động nhắc hạn đăng kiểm (sắp ra mắt)'
}

const BENEFITS_IMAGES = {
  1: benifit1,
  2: benifit2,
  3: benifit3,
  4: benifit4,
  5: benifit5,
  6: benifit6,
  7: benifit7,
  8: benifit8,
  9: benifit9,
  10: benifit10,
  11: benifit11,
  12: benifit1,
  13: benifit2,
  14: benifit3
}

function getBenefits(productOptionalInfo) {
  if (!productOptionalInfo) {
    return []
  }

  if (typeof productOptionalInfo === 'object' && !Array.isArray(productOptionalInfo)) {
    return Array.isArray(productOptionalInfo.benefits) ? productOptionalInfo.benefits : []
  }

  try {
    const parsedInfo = JSON.parse(productOptionalInfo)
    return Array.isArray(parsedInfo?.benefits) ? parsedInfo.benefits : []
  } catch {
    return []
  }
}

export default function AutoTrafficFineNotificationPackageInfo() {
  const history = useHistory()
  const location = useLocation()
  
  const { state } = location
  const vehicleActivePackage = state?.vehicleActivePackage
  const notifyInfoId = vehicleActivePackage?.appUserVehicleNotifyInfoId || vehicleActivePackage?.notifyInfoId || vehicleActivePackage?.id
  const allowRenew01 = Number(vehicleActivePackage?.allowRenew) === 1 ? 1 : 0
  const plate = vehicleActivePackage?.vehicleIdentity || state?.vehicleIdentity || '—'
  const vehicleType = Number(vehicleActivePackage?.vehicleType || state?.vehicleType || 1)
  const productId = Number(vehicleActivePackage?.productId || 0)
  const autoRenewUntil = vehicleActivePackage?.notifyEndDateTime || vehicleActivePackage?.notifyEndDate || ''
  const productNameFromState = vehicleActivePackage?.productName || 'Gói thông báo'

  const [autoRenewEnabled, setAutoRenewEnabled] = useState(() => allowRenew01 === 1)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [product, setProduct] = useState(null)
  const [loadingProduct, setLoadingProduct] = useState(false)

  useEffect(() => {
    let alive = true

    async function run() {
      if (!productId) return

      try {
        setLoadingProduct(true)
        const detail = await userProductService.getUserProductDetailService(productId)
        if (!alive) return
        setProduct(detail || null)
      } catch (e) {
        if (alive) setProduct(null)
      } finally {
        if (alive) setLoadingProduct(false)
      }
    }

    run()
    return () => {
      alive = false
    }
  }, [productId])

  const productName = product?.productName || productNameFromState

  const benefits = useMemo(() => {
    const productOptionalInfo = product?.productOptionalInfo || vehicleActivePackage?.productOptionalInfo
    const benefitsList = getBenefits(productOptionalInfo)
    return benefitsList.map((item) => ({
      text: BENEFITS[item],
      iconSrc: BENEFITS_IMAGES[item]
    }))
  }, [product, vehicleActivePackage])

  const confirmText = autoRenewEnabled
    ? 'Bạn có chắc chắn muốn Ngừng gia hạn tự động gói thông báo này không?'
    : 'Bạn có chắc chắn muốn Gia hạn tự động gói thông báo này không?'

  const onConfirm = async () => {
    if (!notifyInfoId) {
      setConfirmOpen(false)
      return
    }

    setConfirmOpen(false)
    const nextAllowRenew = autoRenewEnabled ? 0 : 1
    try {
      const res = await appUserService.userUpdateNotifyPackage({
        id: Number(notifyInfoId),
        data: { allowRenew: nextAllowRenew }
      })

      if (!res || res.statusCode !== 200) {
        throw res || new Error('UPDATE_NOTIFY_PACKAGE_FAILED')
      }

      setAutoRenewEnabled(nextAllowRenew === 1)
      
      history.replace({
        pathname: location.pathname,
        search: location.search,
        state: {
          ...state,
          vehicleActivePackage: {
            ...vehicleActivePackage,
            allowRenew: nextAllowRenew
          }
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <LayoutPartner headerTitle={'Quản lý gói thông báo'} blendHeaderWithBody={false}>
      <div className="AutoTrafficFineNotificationPackageInfo">
        <div className="AutoTrafficFineNotificationPackageInfo_content" style={{ paddingTop: '20px' }}>
          <NotifyPackageBanner
            plate={plate}
            autoRenewUntil={autoRenewUntil}
            productName={productName}
            allowRenew={autoRenewEnabled ? 1 : 0}
            vehicleType={vehicleType}
          />

          <div className="AutoTrafficFineNotificationPackageInfo_benefits-wrap">
            <BaseTitle style={{ marginBottom: 12 }}>Quyền lợi gói đang sở hữu</BaseTitle>

            <div className="AutoTrafficFineNotificationPackageInfo_benefits-card">
              {loadingProduct ? (
                <BenefitRow text="Đang tải thông tin gói..." iconSrc={trafficFineAutoRenew} />
              ) : benefits.length ? (
                benefits.map((b) => <BenefitRow key={b.text} text={b.text} iconSrc={b.iconSrc} />)
              ) : (
                <BenefitRow text="Chưa có thông tin quyền lợi." />
              )}
            </div>
          </div>

          <FixedBottom elementPaddingBottom="LayoutPartner">
            <BaseButton onClick={() => setConfirmOpen(true)}>
              {autoRenewEnabled ? 'Ngừng gia hạn tự động' : 'Gia hạn tự động'}
            </BaseButton>
          </FixedBottom>
        </div>
      </div>
      <BasePopup
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        title="Thông báo"
        content={confirmText}
        onConfirm={onConfirm}
        closeText="Đóng"
        confirmText="Xác nhận"
      />
    </LayoutPartner>
  )
}
